import { makeStyles } from "@material-ui/core";

export const useUserInfoStyles = makeStyles((theme) => ({

   menuButton: {
      fontWeight: 700,
      size: "18px",
      color: "white",
      alignSelf: "left",
      "&:hover": {
         backgroundColor: theme.palette.primary.light,
         color: "white",
      },
   },
   menuText: {
      cursor: "auto !important",
   },
   subMenu: {
      display: "flex",
      justifyContent: "space-between",
      "& .MuiPaper-root": {
         backgroundColor: theme.palette.primary.main,
      },
      "& .MuiMenuItem-root": {
         color: "white",
      },
      "& .MuiMenuItem-root.Mui-selected": { /* Increase the specificity */
         backgroundColor: theme.palette.secondary.main
      }
   },
}), {index: 1});